import * as types from './actionTypes';
import Immutable from 'seamless-immutable';

const initialState = Immutable({
    status: false,
    loginEmail: '',
    loginFirstName: '',
    loginLastName: '',
    apiToken: '',
    userId: 0,
    eventId: 0,
    loginPassword: '',
    loading: false,
    refreshURL: '',
    error: '',
});

export default function reduce(state = initialState, action = {}) {

    switch (action.type) {
        
        case types.LOGIN_SET:
            return state.merge({
                status: action.status,
                loginEmail: action.email,
                loginFirstName: action.first,
                loginLastName: action.last,
                apiToken: action.token,
                eventId: action.eventId,
                userId: action.id,
            });

        case types.EMAIL_SET:
            return state.merge({
                loginEmail: action.value,
            });

        case types.PASSWORD_SET:
            return state.merge({
                loginPassword: action.value,
            });

        case types.LOADING_SET:
            return state.merge({
                loading: action.value,
            });

        case types.TOKEN_SET:
            return state.merge({
                apiToken: action.value,
            });

        case types.STATUS_SET:
            return state.merge({
                status: action.value,
            });

        case types.URL_SET:
            return state.merge({
                refreshURL: action.value,
            });

        case types.ERROR_SET:
            return state.merge({
                error: action.value,
            });

        default:
            return state;
    }
}

export function getStatus(state) {
    return state.login.status
}

export function getLoading(state) {
    return state.login.loading
}

export function getEmail(state) {
    return state.login.loginEmail
}

export function getPassword(state) {
    return state.login.loginPassword
}

export function getUserId(state) {
    return state.login.userId
}

export function getEventId(state) {
    return state.login.eventId
}

export function getToken(state) {
    return state.login.apiToken
}

export function getURL(state) {
    return state.login.refreshURL
}

export function getError(state) {
    return state.login.error
}
